import React from "react";
import { LoginAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";

export const View = ({ ...props }) => {
  return (
    <LoginAFY
      title={props.title}
      subTitle={props.subTitle}
      logo={props.logo}
      emailText={props.emailText}
      emailPlaceHolder={props.emailPlaceHolder}
      emailRequired={props.emailRequired}
      emailError={props.emailError}
      emailHelperText={props.emailHelperText}
      labelButtonLogin={props.buttonText}
      btnColor="#fffff"
      userForm="PasswordReset"
      onSignIn={props.onSaveData}
    />
  );
};
